<template>
  <v-sheet class="pa-4 primary lighten-2">
    <v-text-field
      v-model="search"
      @input="$emit('searchChange', search)"
      label="Wyszukaj szkolenie"
      dark
      flat
      solo-inverted
      hide-details
      clearable
      clear-icon="mdi-close-circle-outline"
    ></v-text-field>
  </v-sheet>
</template>

<script>
export default {
  data: function() {
    return {
      search: ''
    };
  }
};
</script>
